<template>
    <div>ACCOMPLISHMENT REPORT PAGE</div>
</template>